import React, { useEffect, useState } from "react";
import api from "../api/axios";

function BranchSelect({ value, onChange }) {
  const [branches, setBranches] = useState([]);
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const res = await api.get("/load-branches",
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        setBranches(res.data.data || []); // adjust based on your response shape
      } catch (err) {
        console.error("Failed to load branches", err);
      }
    };
    fetchBranches();
  }, []);

  return (
    <select
        name="branch_id"
        className="form-select"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required
    >
      <option value="">Choose..</option>
      {branches.map((branch) => (
        <option key={branch.id} value={branch.id}>
          {branch.name}
        </option>
      ))}
    </select>
  );
}

export default BranchSelect;
